import React from "react";
import { Alert, Box } from "@mui/material";
import { GrafanaPanel } from "./adapters/GrafanaPanel";
import { PanelActions } from "./PanelActions";

export const PanelRenderer = ({ panel, dashboard }) => {
  const adapter = dashboard.source?.runtime?.panel_adapter;

  if (adapter === "grafana") {
    return (
      <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
        <GrafanaPanel
          panel={panel}
          runtime={dashboard.source.runtime}
          values={dashboard.committedValues}
          grafanaAuth={dashboard.grafanaAuth}
        />

        {panel?.exportable && (
          <Box
            sx={{
              position: "absolute",
              top: 4,
              right: 4,
              zIndex: 2,
            }}
          >
            <PanelActions panel={panel} onExport={dashboard.exportPanel} />
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Alert severity="warning" sx={{ height: "100%", boxSizing: "border-box" }}>
      No hay un adapter configurado para este panel.
    </Alert>
  );
};
